import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DownloadIcon from '@mui/icons-material/Download';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import { Autocomplete, InputAdornment, Stack, TextField, Tooltip } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import ProgressBar from 'src/components/common/ProgressBar';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';
import { sendRequest } from 'src/hooks/useFetch';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { PopupComponent } from '../common/PopupComponent';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export interface IFilterPayload {
  name: string;
  operation: string;
  value: string;
}
export interface ICollapseItem {
  [key: string]: boolean;
}
export interface IFilterActionTypes {
  all: boolean;
  dataEntry: boolean;
  dataChange: boolean;
  fieldQuery: boolean;
  sectionQuery: boolean;
  fromDate: boolean;
  toDate: boolean;
  users: boolean;
  eSign: boolean;
}

export interface IFilterObject {
  filterProps: IFilterActionTypes;
  filterFromDate: string | null;
  filterToDate: string | null;
  filterUsers: string[];
}

export const expandAllTxt = 'EXPAND ALL';
export const collapseAllTxt = 'COLLAPSE ALL';

export const ViewFieldAuditTrail: React.FunctionComponent<any> = ({
  queryKeys,
  queryType,
  openFieldAuditTrail,
  setOpenFieldAuditTrail,
  checkListQueries
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const maxSizeOfAuditDetails = Number.MAX_SAFE_INTEGER;
  const [originalAuditHistory, setOriginalAuditHistory] = useState<any>([]);
  const [paginatedAuditDetails, setPaginatedAuditDetails] = useState<any>([]);
  const [sortBy, setSortBy] = useState('Newest');
  const [expandAll, setExpandAll] = useState(false);
  const [audiFilterDataObj, setAuditFilterDataObj] = useState<any>([]);
  const [queryFilterDataObj, setQueryFilterDataObj] = useState<any>([]);
  const initialFilterObject = {
    filterProps: {
      all: true,
      dataEntry: true,
      dataChange: true,
      eSign: true,
      fieldQuery: true,
      sectionQuery: true,
      fromDate: false,
      toDate: false,
      users: false
    },
    filterFromDate: null,
    filterToDate: null,
    filterUsers: []
  };
  const { preferedFormatForDatePicker, userPreferedDateFormat, preferedDateFormat } = usePreferedDateFormat();
  const exportDateFormat = userPreferedDateFormat.includes('/')
    ? userPreferedDateFormat.replaceAll('/', '_')
    : userPreferedDateFormat.replaceAll('-', '_');
  const [updatedFilterObject, setUpdatedFilterObject] = useState<IFilterObject>(initialFilterObject);
  const [appliedFilterObject, setAppliedFilterObject] = useState<IFilterObject>(initialFilterObject);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [filterSearchValue, setFilterSearchValue] = useState<string>('');
  const [appliedFilterCount, setAppliedFilterCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const perPage = 10;
  const [noOfAuditResults, setNoOfAuditResults] = useState(0);
  const [openFilterSearch, setOpenFilterSearch] = useState(false);
  const dispatch = useAppDispatch();
  const [collapseItems, setCollapseItems] = React.useState<ICollapseItem>({});
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  const headersForCSV = [
    { label: 'Date of Creation', key: 'created_on' },
    { label: 'Date of Change', key: 'date_time_of_change' },
    { label: 'Project Module', key: 'audit_project_module' },
    { label: 'Module Section', key: 'audit_module_section' },
    { label: 'User Name', key: 'audit_user_name' },
    { label: 'Line Item', key: 'field_label' },
    { label: 'Field Name', key: 'field_name' },
    { label: 'Field Data', key: 'data_changed_from' },
    { label: 'Previous Data (if any)', key: 'previous_data' },
    { label: 'Reason for Change', key: 'reason_for_change' },
    { label: 'Action Type', key: 'reason_data_changed' },
    { label: 'Query_SentTo', key: 'query_sent_to' },
    { label: 'Query_ResponseUser', key: 'query_respond_user' }
  ];
  const getAuditModuleSection = () => {
    return queryKeys.report_category === 'SUSIVRT'
      ? 'SIV REPORT'
      : queryKeys.report_category === 'SUSIVRT'
      ? 'SQ REPORT'
      : queryKeys.report_category === 'SUMILST'
      ? 'MILESTONE TRACKING'
      : '';
  };
  const getAuditHistory = async (
    recordId: string,
    startFrom: number,
    maxSize: number,
    sortOrder: string,
    fieldFilter: any[],
    queryFilter: any[]
  ) => {
    setPaginatedAuditDetails([]);
    let allAuditFilterData: any = [];
    let fieldFilterData = [...fieldFilter];
    let queryFilterData = [
      ...queryFilter,
      {
        name: 'report_category',
        operation: 'equals',
        value: queryKeys.report_category
      }
    ];
    try {
      setFilterSearchValue('');
      setIsLoading(true);
      if (queryKeys.id != undefined && queryKeys.id != '') {
        if (updatedFilterObject.filterProps.all || fieldFilter.length != 0) {
          if (queryType !== 'ALL') {
            fieldFilterData = [
              ...fieldFilterData,
              {
                name: 'field_changed',
                operation: 'in',
                value:
                  queryKeys.report_field_name_comm !== ''
                    ? [queryKeys.report_field_name, queryKeys.report_field_name_comm]
                    : [queryKeys.report_field_name]
              }
            ];
          } else {
            const allFieldsPerSection: string[] = [];
            Object.keys(checkListQueries).map((checkList, i) => {
              if (checkList === queryKeys.section_key) {
                Object.keys(checkListQueries[checkList]).map((field, j) => {
                  allFieldsPerSection.push(checkListQueries[checkList][field].report_field_name);
                  if (checkListQueries[checkList][field].report_field_name_comm != '') {
                    allFieldsPerSection.push(checkListQueries[checkList][field].report_field_name_comm);
                  }
                });
              }
            });
            fieldFilterData = [
              ...fieldFilterData,
              {
                name: 'field_changed',
                operation: 'in',
                value: allFieldsPerSection
              }
            ];
          }
          const options = {
            audit_module_section: getAuditModuleSection(),
            row_id: recordId,
            pathVariables: {
              study_id: studyId,
              site_id: selectedSite,
              country: selectedCountry,
              appName: process.env.REACT_APP_NAME,
              isOnlyUpdate: false,
              startFrom,
              maxSize,
              sortbyColumn: 'date_time_of_change',
              sortOrder
            },
            data: fieldFilterData
          };
          //Field changes
          const fieldChangesResponse = sendRequest('audit_applying_filters', options);
          const [auditData]: any = await Promise.all([fieldChangesResponse]);
          allAuditFilterData = auditData.map((audit: any) => {
            audit.field_label =
              queryType === 'Field' ? queryKeys.report_field_label : getFieldLabelByFieldName(audit.field_changed);
            audit.changed_data = changeViewData(audit.changed_data);
            audit.data_changed_from = changeViewData(audit.data_changed_from);
            return audit;
          });
        }
      }

      if (updatedFilterObject.filterProps.all || queryFilter.length != 0) {
        queryFilterData = [
          ...queryFilterData,
          {
            name: 'report_section_name',
            operation: 'equals',
            value: queryKeys.report_section_name
          }
        ];
        const options = {
          site_id: selectedSite,
          study_id: studyId,
          pathVariables: {
            country: selectedCountry,
            appName: process.env.REACT_APP_NAME,
            startFrom,
            maxSize,
            sortbyColumn: 'created_on',
            sortOrder
          },
          data: queryFilterData
        };
        const queriesAndResponses = sendRequest('query_applying_filters', options);
        try {
          const [queryResponse]: any = await Promise.all([queriesAndResponses]);
          let filteredQueries = [];
          if (queryType !== 'ALL') {
            filteredQueries = queryResponse.filter(
              (item: any) =>
                (item.query.report_query_type === 'Field' &&
                  item.query.report_section_name === queryKeys.report_section_name &&
                  item.query.report_field_label === queryKeys.report_field_label &&
                  item.query.report_field_name === queryKeys.report_field_name) ||
                (item.query.report_query_type === 'Section' &&
                  item.query.report_section_name === queryKeys.report_section_name)
            );
          } else {
            filteredQueries = queryResponse.filter(
              (item: any) =>
                (item.query.report_query_type === 'Field' || item.query.report_query_type === 'Section') &&
                item.query.report_section_name === queryKeys.report_section_name
            );
          }

          if (filteredQueries) {
            const filteredQueryData = filteredQueries.map((element: any) => {
              element.query.reason_data_changed = `${element.query.report_query_type} Query`;
              element.query.date_time_of_change = element.query.updated_on;
              if (element.responses) {
                return { ...element.query, responses: [...element.responses] };
              } else {
                return { ...element.query, responses: [] };
              }
            });
            if (allAuditFilterData.length != 0) {
              allAuditFilterData = allAuditFilterData.concat(filteredQueryData);
              allAuditFilterData = sortingAuditTrailData(allAuditFilterData);
            } else {
              allAuditFilterData = filteredQueryData;
            }
          }
        } catch (error: any) {
          if (error.response.status === 404) {
            setIsLoading(false);
          }
        }
      }
      setPage(1);
      setNoOfAuditResults(allAuditFilterData.length);
      setOriginalAuditHistory(allAuditFilterData);
      setPaginationWithGroupBy(allAuditFilterData, 1);
      setIsLoading(false);
    } catch (error) {
      if (updatedFilterObject.filterProps.all || queryFilter.length != 0) {
        queryFilterData = [
          ...queryFilterData,
          {
            name: 'report_section_name',
            operation: 'equals',
            value: queryKeys.report_section_name
          }
        ];
        const options = {
          site_id: selectedSite,
          study_id: studyId,
          pathVariables: {
            country: selectedCountry,
            appName: process.env.REACT_APP_NAME,
            startFrom,
            maxSize,
            sortbyColumn: 'created_on',
            sortOrder
          },
          data: queryFilterData
        };
        const queriesAndResponses = sendRequest('query_applying_filters', options);
        try {
          const [queryResponse]: any = await Promise.all([queriesAndResponses]);
          let filteredQueries = [];
          if (queryType !== 'ALL') {
            filteredQueries = queryResponse.filter(
              (item: any) =>
                (item.query.report_query_type === 'Field' &&
                  item.query.report_section_name === queryKeys.report_section_name &&
                  item.query.report_field_label === queryKeys.report_field_label &&
                  item.query.report_field_name === queryKeys.report_field_name) ||
                (item.query.report_query_type === 'Section' &&
                  item.query.report_section_name === queryKeys.report_section_name)
            );
          } else {
            filteredQueries = queryResponse.filter(
              (item: any) =>
                (item.query.report_query_type === 'Field' || item.query.report_query_type === 'Section') &&
                item.query.report_section_name === queryKeys.report_section_name
            );
          }
          if (filteredQueries) {
            const filteredQueryData = filteredQueries.map((element: any) => {
              element.query.reason_data_changed = `${element.query.report_query_type} Query`;
              element.query.date_time_of_change = element.query.updated_on;
              if (element.responses) {
                return { ...element.query, responses: [...element.responses] };
              } else {
                return { ...element.query, responses: [] };
              }
            });
            setPage(1);
            setNoOfAuditResults(filteredQueryData.length);
            setOriginalAuditHistory(filteredQueryData);
            setPaginationWithGroupBy(filteredQueryData, 1);
            setIsLoading(false);
          }
        } catch (error: any) {
          if (error.response.status === 404) {
            setIsLoading(false);
            setNoOfAuditResults(allAuditFilterData.length);
            setOriginalAuditHistory(allAuditFilterData);
            setPaginatedAuditDetails([]);
          }
        }
      } else {
        setIsLoading(false);
        setNoOfAuditResults(allAuditFilterData.length);
        setOriginalAuditHistory(allAuditFilterData);
        setPaginatedAuditDetails([]);
      }
    }
  };

  const setPaginationWithGroupBy = (allAuditHistory: any[], pageNumber: number) => {
    if (allAuditHistory) {
      const datedAudit = allAuditHistory.map((el: any) => {
        return {
          ...el,
          date_change: String(el.date_time_of_change).split('T')[0]
        };
      });
      const begin = (pageNumber - 1) * perPage;
      const paginatedResponse = datedAudit.slice(begin, begin + perPage);
      setPaginatedAuditDetails(groupBy(paginatedResponse, 'date_change'));
    } else {
      setPaginatedAuditDetails(allAuditHistory);
    }
  };
  const sortingAuditTrailData = (combinedData: any) => {
    if (sortBy === 'Newest') {
      return combinedData.sort((a: any, b: any) => +new Date(b.date_time_of_change) - +new Date(a.date_time_of_change));
    } else {
      return combinedData.sort((a: any, b: any) => +new Date(a.date_time_of_change) - +new Date(b.date_time_of_change));
    }
  };
  const groupBy = (collection: any, property: string) => {
    let i = 0,
      val,
      index;
    const values = [];
    const result = [];
    for (; i < collection.length; i++) {
      val = collection[i][property];
      index = values.indexOf(val);
      if (index > -1) {
        result[index].push(collection[i]);
      } else {
        values.push(val);
        result.push([collection[i]]);
      }
    }
    return result;
  };

  useEffect(() => {
    if (openFieldAuditTrail) {
      getAuditHistory(
        queryKeys.id,
        0,
        maxSizeOfAuditDetails,
        sortBy == 'Newest' ? 'desc' : 'asc',
        audiFilterDataObj,
        queryFilterDataObj
      );
    } else {
      setUpdatedFilterObject(initialFilterObject);
      setAppliedFilterObject(initialFilterObject);
      setAppliedFilterCount(0);
      setExpandAll(false);
      setAuditFilterDataObj([]);
      setQueryFilterDataObj([]);
      setFilterSearchValue('');
      setSortBy('Newest');
    }
  }, [openFieldAuditTrail, sortBy]);

  const handleSearch = (event: any) => {
    const searchValue: string = event.target.value;
    setFilterSearchValue(searchValue);
    if (searchValue != '') {
      filterAuditList(searchValue);
    } else {
      setNoOfAuditResults(originalAuditHistory.length);
      setPaginationWithGroupBy(originalAuditHistory, 1);
      setPage(1);
    }
  };

  const filterAuditList = (value: string) => {
    const filtered = originalAuditHistory.filter((data: any) => {
      if ('report_query_type' in data) {
        if (
          data.reason_data_changed?.toLowerCase().includes(value.toLowerCase()) ||
          data.report_field_name?.toLowerCase().includes(value.toLowerCase()) ||
          data.report_comment?.toLowerCase().includes(value.toLowerCase()) ||
          data.report_field_label?.toLowerCase().includes(value.toLowerCase()) ||
          data.report_section_name?.toLowerCase().includes(value.toLowerCase()) ||
          data.report_forward_to?.toLowerCase().includes(value.toLowerCase()) ||
          data.report_send_to?.toLowerCase().includes(value.toLowerCase()) ||
          data.updated_by?.toLowerCase().includes(value.toLowerCase()) ||
          data.created_by?.toLowerCase().includes(value.toLowerCase()) ||
          data.report_section_query_id_v?.toLowerCase().includes(value.toLowerCase()) ||
          data.report_field_query_id_v?.toLowerCase().includes(value.toLowerCase()) ||
          data.responses?.some(
            (resCheck: any) =>
              resCheck.query_response?.toLowerCase().includes(value.toLowerCase()) ||
              resCheck.created_by?.toLowerCase().includes(value.toLowerCase())
          )
        ) {
          return data;
        }
      } else {
        if (
          data.reason_data_changed?.toLowerCase().includes(value.toLowerCase()) ||
          data.field_changed?.toLowerCase().includes(value.toLowerCase()) ||
          data.field_label?.toLowerCase().includes(value.toLowerCase()) ||
          data.changed_data?.toLowerCase().includes(value.toLowerCase()) ||
          data.audit_user_name?.toLowerCase().includes(value.toLowerCase()) ||
          data.data_changed_from?.toLowerCase().includes(value.toLowerCase())
        ) {
          return data;
        }
      }
    });
    setNoOfAuditResults(filtered.length);
    setPaginationWithGroupBy(filtered, 1);
    setPage(1);
  };

  const handleFilterApply = () => {
    let filterCount = 0;
    const tempFieldFilters: any[] = [];
    const tempQueryFilters: any[] = [];
    if (
      updatedFilterObject.filterProps.all ||
      updatedFilterObject.filterProps.dataChange ||
      updatedFilterObject.filterProps.dataEntry ||
      updatedFilterObject.filterProps.eSign ||
      updatedFilterObject.filterProps.fieldQuery ||
      updatedFilterObject.filterProps.sectionQuery
    ) {
      if (updatedFilterObject.filterFromDate != 'Invalid date' && updatedFilterObject.filterToDate != 'Invalid date') {
        const isToDateValid =
          updatedFilterObject.filterFromDate !== null && updatedFilterObject.filterToDate !== null
            ? moment(updatedFilterObject.filterToDate) >= moment(updatedFilterObject.filterFromDate)
            : true;
        if (isToDateValid) {
          if (updatedFilterObject.filterProps.all) {
            filterCount = 0;
          } else if (
            updatedFilterObject.filterProps.dataChange ||
            updatedFilterObject.filterProps.dataEntry ||
            updatedFilterObject.filterProps.eSign ||
            updatedFilterObject.filterProps.fieldQuery ||
            updatedFilterObject.filterProps.sectionQuery
          ) {
            filterCount = filterCount + 1;
            const dataChangedArr: string[] = [];
            if (updatedFilterObject.filterProps.dataChange) {
              dataChangedArr.push('Data Update');
            }
            if (updatedFilterObject.filterProps.dataEntry) {
              dataChangedArr.push('Data Entry');
            }
            if (updatedFilterObject.filterProps.eSign) {
              dataChangedArr.push('eSign');
            }
            tempFieldFilters.push({
              name: 'reason_data_changed',
              value: dataChangedArr,
              operation: 'in'
            });
            const queryChangeArr: string[] = [];
            if (updatedFilterObject.filterProps.fieldQuery) {
              queryChangeArr.push('Field');
            }
            if (updatedFilterObject.filterProps.sectionQuery) {
              queryChangeArr.push('Section');
            }
            tempQueryFilters.push({
              name: 'report_query_type',
              value: queryChangeArr,
              operation: 'in'
            });
          }
          if (updatedFilterObject.filterProps.fromDate || updatedFilterObject.filterProps.toDate) {
            filterCount = filterCount + 1;
            if (updatedFilterObject.filterFromDate) {
              if (updatedFilterObject.filterProps.dataChange || updatedFilterObject.filterProps.dataEntry) {
                tempFieldFilters.push({
                  name: 'date_time_of_change',
                  value: updatedFilterObject.filterFromDate,
                  operation: 'greater_than_or_equal'
                });
              }
              if (updatedFilterObject.filterProps.fieldQuery || updatedFilterObject.filterProps.sectionQuery) {
                tempQueryFilters.push({
                  name: 'created_on',
                  value: updatedFilterObject.filterFromDate,
                  operation: 'greater_than_or_equal'
                });
              }
            }
            if (updatedFilterObject.filterToDate) {
              if (
                updatedFilterObject.filterProps.dataChange ||
                updatedFilterObject.filterProps.dataEntry ||
                updatedFilterObject.filterProps.eSign
              ) {
                tempFieldFilters.push({
                  name: 'date_time_of_change',
                  value: updatedFilterObject.filterToDate,
                  operation: 'less_than_or_equal'
                });
              }
              if (updatedFilterObject.filterProps.fieldQuery || updatedFilterObject.filterProps.sectionQuery) {
                tempQueryFilters.push({
                  name: 'created_on',
                  value: updatedFilterObject.filterToDate,
                  operation: 'less_than_or_equal'
                });
              }
            }
          }
          if (updatedFilterObject.filterProps.users) {
            if (updatedFilterObject.filterUsers.length) {
              filterCount = filterCount + 1;
              if (
                updatedFilterObject.filterProps.dataChange ||
                updatedFilterObject.filterProps.dataEntry ||
                updatedFilterObject.filterProps.eSign
              ) {
                tempFieldFilters.push({
                  name: 'audit_user_name',
                  value: updatedFilterObject.filterUsers,
                  operation: 'in'
                });
              }
              if (updatedFilterObject.filterProps.fieldQuery || updatedFilterObject.filterProps.sectionQuery) {
                tempQueryFilters.push({
                  name: 'created_by',
                  value: updatedFilterObject.filterUsers,
                  operation: 'in'
                });
              }
            }
          }
          setAppliedFilterObject(updatedFilterObject);
          setAppliedFilterCount(filterCount);
          setAuditFilterDataObj(tempFieldFilters);
          setQueryFilterDataObj(tempQueryFilters);
          setOpenFilterSearch(false);
          getAuditHistory(
            queryKeys.id,
            0,
            maxSizeOfAuditDetails,
            sortBy == 'Newest' ? 'desc' : 'asc',
            tempFieldFilters,
            tempQueryFilters
          );
        } else {
          // store.dispatch(setSnackbarMessage(, ));
          dispatch(setMessage({ msgDetails: 'To date should be less than or equal to from date.', severity: 'error' }));
        }
      } else {
        // store.dispatch(setSnackbarMessage('Invalid Date(s).', 'error'));
        dispatch(setMessage({ msgDetails: 'Invalid Date(s)', severity: 'error' }));
      }
    } else {
      filterCount = filterCount + 1;
      setAppliedFilterObject(updatedFilterObject);
      setAppliedFilterCount(filterCount);
      setAuditFilterDataObj(tempFieldFilters);
      setQueryFilterDataObj(tempQueryFilters);
      setOpenFilterSearch(false);
      getAuditHistory(
        queryKeys.id,
        0,
        maxSizeOfAuditDetails,
        sortBy == 'Newest' ? 'desc' : 'asc',
        tempFieldFilters,
        tempQueryFilters
      );
    }
  };

  const getFieldLabelByFieldName = (fieldName: string) => {
    let label = '';
    Object.keys(checkListQueries).map((checkList: any) => {
      if (checkList === queryKeys.section_key) {
        Object.keys(checkListQueries[checkList]).map((field, _) => {
          if (checkListQueries[checkList][field].report_field_name === fieldName.replace('_comm', '')) {
            label = checkListQueries[checkList][field].report_field_label;
          }
        });
      }
    });
    return label;
  };

  const preparedCSVData = (allAudit: any[]) => {
    const csvData: any = [];
    allAudit.map((trail: any) => {
      if ('report_query_type' in trail) {
        csvData.push({
          created_on: moment(new Date(trail.created_on))
            .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
            .toString(),
          date_time_of_change: '',
          audit_project_module: 'STARTUP',
          audit_module_section: getAuditModuleSection().toUpperCase(),
          audit_user_name: trail.created_by,
          field_label: getFieldLabelByFieldName(trail.report_field_name),
          field_name: trail.report_field_name,
          data_changed_from: trail.report_comment,
          previous_data: '',
          reason_for_change: '',
          reason_data_changed:
            trail.report_forward_to !== ''
              ? `${trail.reason_data_changed}-ForwardedTo`
              : `${trail.reason_data_changed}-Raised`,
          query_sent_to: trail.report_forward_to !== '' ? trail.report_forward_to : trail.report_send_to,
          query_respond_user: ''
        });
        if (trail.responses.length > 0) {
          trail.responses.map((res: any) => {
            csvData.push({
              created_on: moment(new Date(trail.created_on))
                .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
                .toString(),
              date_time_of_change: '',
              audit_project_module: 'STARTUP',
              audit_module_section: getAuditModuleSection().toUpperCase(),
              audit_user_name: res.created_by,
              field_label: getFieldLabelByFieldName(trail.report_field_name),
              field_name: trail.report_field_name,
              data_changed_from: res.query_response,
              previous_data: '',
              reason_for_change: '',
              reason_data_changed: `${trail.reason_data_changed}-Responded`,
              query_sent_to: trail.report_forward_to !== '' ? trail.report_forward_to : trail.report_send_to,
              query_respond_user: res.created_by
            });
          });
        }
      } else {
        csvData.push({
          created_on: moment(new Date(trail.created_on))
            .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
            .toString(),
          date_time_of_change: moment(new Date(trail.date_time_of_change))
            .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
            .toString(),
          audit_project_module: trail.audit_project_module,
          audit_module_section: trail.audit_module_section.toUpperCase(),
          audit_user_name: trail.audit_user_name,
          field_label: trail.field_label,
          field_name: trail.field_changed,
          data_changed_to: trail.changed_data,
          previous_data: trail.data_changed_from,
          reason_for_change: '',
          reason_data_changed: trail.reason_data_changed,
          query_sent_to: '',
          query_respond_user: ''
        });
      }
    });
    return csvData;
  };

  const handleSortbyChange = (e: any) => {
    setSortBy(e.target.value);
  };

  const handlePrint = () => {
    setPaginatedAuditDetails(groupBy(originalAuditHistory, 'date_change'));
    setTimeout(() => {
      window.print();
    }, 300);
    setTimeout(() => {
      setPaginationWithGroupBy(originalAuditHistory, page);
    }, 300);
  };

  const handlePagination = (event: React.ChangeEvent<unknown>, value: number) => {
    if (value !== page) {
      setPaginationWithGroupBy(originalAuditHistory, value);
    }
    setPage(value);
  };

  const handleCloseFieldAudit = () => {
    setOpenFieldAuditTrail(false);
  };

  const handleFilterClear = () => {
    setAuditFilterDataObj([]);
    setQueryFilterDataObj([]);
    setUpdatedFilterObject(initialFilterObject);
    setFilterSearchValue('');
  };

  const changeViewData = (changedValue: any) => {
    if (changedValue === 'Y' || changedValue === 'N') {
      return changedValue === 'Y' ? 'Yes' : 'No';
    } else if (changedValue === 'None') {
      return '';
    } else {
      return changedValue;
    }
  };

  const handleTimeAmPm = (time: any) => {
    const timeString = time.slice(11, 19);
    const timeString12hr = new Date(`1970-01-01T${timeString}Z`).toLocaleTimeString('en-US', {
      timeZone: 'UTC',
      hour12: true,
      hour: 'numeric',
      minute: 'numeric'
    });
    return timeString12hr;
  };

  const handleClickExpandAll = () => {
    const expandState = getText() === expandAllTxt ? true : false;
    setCollapseItems({} as ICollapseItem);
    setExpandAll(expandState);
  };

  const handleChangeAccordion = (_: React.SyntheticEvent<Element, Event>, expanded: boolean, id: string) => {
    const newCollapse: ICollapseItem = { ...collapseItems };
    newCollapse[id] = expanded;
    setCollapseItems(newCollapse);
  };

  const getExpandAndCollapseState = (id: string): boolean => {
    let result = expandAll;
    if (collapseItems[id] !== undefined) {
      result = collapseItems[id];
    }
    return result;
  };

  const getText = () => {
    let txt = expandAllTxt;
    const expandedItems = Object.entries(collapseItems).filter(item => item[1]);
    const collapsedItems = Object.entries(collapseItems).filter(item => !item[1]);
    txt = expandAll ? collapseAllTxt : expandAllTxt;
    if (Object.entries(collapseItems).length > 0 && (collapsedItems.length > 0 || expandedItems.length > 0)) {
      if (paginatedAuditDetails.length === collapsedItems.length) {
        txt = expandAllTxt;
      } else if (paginatedAuditDetails.length === expandedItems.length) {
        txt = collapseAllTxt;
      } else {
        txt = expandAllTxt;
      }
    }
    return txt;
  };

  const handleUsersChange = (_: any, values: any) => {
    setUpdatedFilterObject({
      ...updatedFilterObject,
      filterProps: {
        ...updatedFilterObject.filterProps,
        users: true
      },
      filterUsers: values
    });
  };

  const handleActionTypeChange = (event: any, actionType: string) => {
    const value = event.target.checked;
    let checkFilterObj = { ...updatedFilterObject };
    if (actionType === 'All') {
      checkFilterObj = {
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          all: value,
          dataChange: value,
          dataEntry: value,
          fieldQuery: value,
          sectionQuery: value
        }
      };
    } else {
      checkFilterObj = {
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          all: false,
          [actionType]: value
        }
      };
      if (
        checkFilterObj.filterProps.dataChange &&
        checkFilterObj.filterProps.dataEntry &&
        checkFilterObj.filterProps.eSign &&
        checkFilterObj.filterProps.fieldQuery &&
        checkFilterObj.filterProps.sectionQuery
      ) {
        checkFilterObj = {
          ...checkFilterObj,
          filterProps: {
            ...checkFilterObj.filterProps,
            all: true
          }
        };
      }
    }
    setUpdatedFilterObject(checkFilterObj);
  };

  const handleFilterDateChange = (dateValue: any, fromOrTo: string) => {
    if (fromOrTo === 'filterFromDate') {
      setUpdatedFilterObject({
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          fromDate: dateValue && dateValue !== null ? true : false
        },
        filterFromDate:
          dateValue && dateValue !== null
            ? moment(new Date(dateValue).toLocaleDateString('en-CA')).format(`${SERVER_DATE_FORMAT} 00:00:00`)
            : null
      });
    } else {
      setUpdatedFilterObject({
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          toDate: dateValue && dateValue !== null ? true : false
        },
        filterToDate:
          dateValue && dateValue !== null
            ? moment(new Date(dateValue).toLocaleDateString('en-CA')).format(`${SERVER_DATE_FORMAT} 23:59:59`)
            : null
      });
    }
  };

  const handleClickOpenFilterSearch = () => {
    setOpenFilterSearch(true);
    setUpdatedFilterObject(appliedFilterObject);
  };

  const handleCloseFilterSearch = () => {
    setOpenFilterSearch(false);
    setUpdatedFilterObject(appliedFilterObject);
  };

  const [usersList, setUsersList] = useState([]);
  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();

  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = assignees.map((item: any) => `${item.first_name} ${item.last_name}`);
      setUsersList(assignList);
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError]);

  useEffect(() => {
    if (openFieldAuditTrail) {
      if (queryKeys.report_category && queryKeys.report_category !== '' && queryKeys.report_category !== null) {
        if (queryKeys.report_category === 'SUSIVRT' && usersList.length === 0) {
          getAssignees({
            client_name: 'ctms-ui',
            data: ['UPDATE_SIV_REPORT', 'RAISE_QUERY_SIV_REPORT', 'DELETE_QUERY_SIV_REPORT', 'RESPOND_QUERY_SIV_REPORT']
          });
        } else {
          getAssignees({
            client_name: 'ctms-ui',
            data: ['UPDATE_SQ_REPORT', 'DELETE_QUERY_SQ_REPORT', 'RAISE_QUERY_SQ_REPORT', 'RESPOND_QUERY_SQ_REPORT']
          });
        }
      }
    }
  }, [openFieldAuditTrail]);

  const popupComponentProps = { open: openFilterSearch, BackdropProps: { invisible: true } };
  const extentedPopupProps =
    queryKeys.report_category === 'SUMILST'
      ? popupComponentProps
      : { ...popupComponentProps, onClose: handleCloseFilterSearch, child: true };

  return (
    <div className="modal-view">
      <PopupComponent aria-labelledby="customized-dialog-title" open={openFieldAuditTrail} maxWidth="md">
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {queryType === 'ALL' ? 'Audit Trail' : 'Field Audit Trail'}
          <Stack direction="row" spacing={2} className="print-actions audit-print" id="no-print" columnGap={2}>
            <Tooltip title="Print" arrow placement="top">
              <IconButton
                onClick={e => handlePrint()}
                className="grey-btn"
                disabled={paginatedAuditDetails.length === 0}
              >
                <LocalPrintshopIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download as CSV" arrow placement="top">
              <IconButton className="grey-btn" disabled={paginatedAuditDetails.length === 0}>
                <CSVLink
                  headers={headersForCSV}
                  data={preparedCSVData(originalAuditHistory)}
                  filename={`${queryKeys.report_category === 'SUSIVRT' ? 'SIVReport' : 'SQReport'}_${
                    queryType === 'Field' ? 'Field' : 'All'
                  }AuditTrail_${moment(new Date()).format(`${exportDateFormat.toUpperCase()} HH:mm:ss`)}.csv`}
                >
                  <DownloadIcon />
                </CSVLink>
              </IconButton>
            </Tooltip>
          </Stack>
        </DialogTitle>
        <DialogContent className="audit-history-modal">
          <div className="audit-card">
            <Grid container spacing={0}>
              <Grid item md={12}>
                <Box sx={{ bgcolor: 'background.paper', pt: 0 }}>
                  <Grid container>
                    <Box
                      bgcolor="white"
                      sx={{
                        width: '100%',
                        position: 'sticky',
                        top: '0',
                        zIndex: 100,
                        transition: 'top 300ms ease-in-out'
                      }}
                    >
                      <Grid container className="search-block" id="no-print">
                        <Grid item md={10}>
                          <FormControl variant="standard" sx={{ pr: 2, mt: 2 }}>
                            <TextField
                              id="input-with-icon-adornment"
                              variant="standard"
                              autoFocus
                              placeholder="Search Audit"
                              value={filterSearchValue}
                              onChange={e => handleSearch(e)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span id="group">
                                      <IconButton
                                        aria-label="more"
                                        id="search-filter-IconButton"
                                        aria-controls={openFilterSearch ? 'search-filter' : undefined}
                                        aria-expanded={openFilterSearch ? 'true' : undefined}
                                        aria-haspopup="true"
                                        onClick={handleClickOpenFilterSearch}
                                      >
                                        <TuneIcon />
                                      </IconButton>
                                      {appliedFilterCount > 0 && (
                                        <span className="badge badge-light">{appliedFilterCount}</span>
                                      )}
                                    </span>

                                    <PopupComponent {...extentedPopupProps}>
                                      <DialogTitle>
                                        <Typography variant="h6" component="div" sx={{ mb: 1 }}>
                                          Filters
                                          <Button
                                            sx={{ mr: 2, position: 'absolute', right: 0 }}
                                            variant="text"
                                            href=""
                                            onClick={handleFilterClear}
                                          >
                                            CLEAR
                                          </Button>
                                        </Typography>
                                      </DialogTitle>
                                      <DialogContent>
                                        <Grid
                                          container
                                          direction="row"
                                          justifyContent="space-between"
                                          className="filterAH"
                                        >
                                          <Grid item md={5}>
                                            <FormControl component="fieldset" variant="standard" margin="normal">
                                              <FormLabel component="legend" sx={{ mb: 1 }}>
                                                Action Type
                                              </FormLabel>
                                              <FormGroup>
                                                <Stack direction="column" spacing={1}>
                                                  <FormControlLabel
                                                    sx={{ ml: 0 }}
                                                    control={
                                                      <Switch
                                                        checked={updatedFilterObject.filterProps.all}
                                                        onChange={e => handleActionTypeChange(e, 'All')}
                                                        size="small"
                                                      />
                                                    }
                                                    label="All"
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={updatedFilterObject.filterProps.dataEntry}
                                                        onChange={e => handleActionTypeChange(e, 'dataEntry')}
                                                        size="small"
                                                      />
                                                    }
                                                    label="Data Entry"
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={updatedFilterObject.filterProps.dataChange}
                                                        onChange={e => handleActionTypeChange(e, 'dataChange')}
                                                        size="small"
                                                      />
                                                    }
                                                    label="Data Change"
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={updatedFilterObject.filterProps.fieldQuery}
                                                        onChange={e => handleActionTypeChange(e, 'fieldQuery')}
                                                        size="small"
                                                      />
                                                    }
                                                    label="Field Query"
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={updatedFilterObject.filterProps.sectionQuery}
                                                        onChange={e => handleActionTypeChange(e, 'sectionQuery')}
                                                        size="small"
                                                      />
                                                    }
                                                    label="Section Query"
                                                  />
                                                </Stack>
                                              </FormGroup>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={7}>
                                            <FormControl fullWidth margin="normal">
                                              <FormLabel id="" sx={{ mb: 1 }}>
                                                Date
                                              </FormLabel>
                                            </FormControl>
                                            <Grid container spacing={3} sx={{ mb: 2, display: 'flex' }}>
                                              <Grid item md={6}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDayjs}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DatePicker
                                                    label="From"
                                                    inputFormat={userPreferedDateFormat.toUpperCase()}
                                                    value={
                                                      updatedFilterObject.filterFromDate !== null
                                                        ? preferedFormatForDatePicker(
                                                            updatedFilterObject.filterFromDate?.split(' ')[0]
                                                          )
                                                        : null
                                                    }
                                                    onChange={(newValue: Date | null) => {
                                                      handleFilterDateChange(newValue, 'filterFromDate');
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField {...params} variant="standard" />
                                                    )}
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                              <Grid item md={6}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDayjs}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DatePicker
                                                    label="To"
                                                    inputFormat={userPreferedDateFormat.toUpperCase()}
                                                    value={
                                                      updatedFilterObject.filterToDate !== null
                                                        ? preferedFormatForDatePicker(
                                                            updatedFilterObject.filterToDate?.split(' ')[0]
                                                          )
                                                        : null
                                                    }
                                                    onChange={(newValue: Date | null) => {
                                                      handleFilterDateChange(newValue, 'filterToDate');
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField {...params} variant="standard" />
                                                    )}
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                            </Grid>

                                            <FormControl fullWidth margin="normal">
                                              <FormLabel id="" sx={{ mb: 1 }}>
                                                User
                                              </FormLabel>
                                            </FormControl>
                                            <FormControl fullWidth variant="standard">
                                              <Autocomplete
                                                multiple
                                                id="filter-select-user"
                                                options={usersList}
                                                value={updatedFilterObject.filterUsers}
                                                onChange={handleUsersChange}
                                                renderInput={(params: any) => (
                                                  <TextField {...params} variant="standard" label="User(s)" />
                                                )}
                                              />
                                            </FormControl>
                                          </Grid>
                                        </Grid>
                                      </DialogContent>
                                      <DialogActions>
                                        <Grid container spacing={2}>
                                          <Grid item md={12} display="flex" justifyContent="flex-end">
                                            <Stack direction="row" spacing={2}>
                                              <Button variant="text" onClick={handleFilterApply}>
                                                Apply
                                              </Button>
                                            </Stack>
                                          </Grid>
                                        </Grid>
                                      </DialogActions>
                                    </PopupComponent>
                                  </InputAdornment>
                                )
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={2}>
                          <FormControl variant="standard" sx={{ mb: 2 }}>
                            <InputLabel id="demo-simple-select-standard-label">Sort By</InputLabel>
                            <Select
                              labelId="demo-simple-select-standard-label"
                              id="demo-simple-select-standard"
                              value={sortBy}
                              onChange={e => {
                                handleSortbyChange(e);
                              }}
                            >
                              <MenuItem value="Newest">Newest</MenuItem>
                              <MenuItem value="Oldest">Oldest</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      {Object.keys(paginatedAuditDetails).length !== 0 && (
                        <Grid
                          id="no-print"
                          md={12}
                          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', mb: 0.5 }}
                        >
                          <Button variant="text" onClick={handleClickExpandAll}>
                            {getText()}
                          </Button>
                        </Grid>
                      )}
                    </Box>

                    <Grid id="fieldAuditsPerPage" container>
                      <Grid item md={12} className="audit-trail-list">
                        <Grid container>
                          <Grid item md={12}>
                            {isLoading && <ProgressBar />}
                            {paginatedAuditDetails.length
                              ? paginatedAuditDetails.map((auditDetails: any, index1: number) => (
                                  <Box sx={{ mb: 2 }} key={auditDetails.date_change}>
                                    <Grid container>
                                      <Grid md={8}>
                                        <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                                          {monthNames[new Date(auditDetails[0].date_time_of_change).getMonth()]}{' '}
                                          {new Date(auditDetails[0].date_time_of_change).getDate()},{' '}
                                          {new Date(auditDetails[0].date_time_of_change).getFullYear()}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    {auditDetails.map((item: any, index: number) => {
                                      return (
                                        <>
                                          {item.reason_data_changed == 'Data Entry' ||
                                          item.reason_data_changed == 'Data Update' ||
                                          item.reason_data_changed == 'eSign' ? (
                                            <Accordion
                                              key={item.id}
                                              disabled={false}
                                              expanded={getExpandAndCollapseState(item.id)}
                                              onChange={(e, expanded) => {
                                                handleChangeAccordion(e, expanded, item.id);
                                              }}
                                              className="CustomAccordion-AH"
                                            >
                                              <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1bh-content"
                                                id="panel1bh-header"
                                              >
                                                <Box>
                                                  <Stack
                                                    spacing={1.5}
                                                    direction="row"
                                                    sx={{ alignItems: 'center', mb: 1 }}
                                                  >
                                                    <Typography variant="h6" component="div">
                                                      {queryKeys.report_section_name}: {item.field_changed}
                                                    </Typography>
                                                    <Typography variant="body2" gutterBottom>
                                                      <span>
                                                        {`${preferedDateFormat(
                                                          item.date_time_of_change.split('T')[0]
                                                        )} ${handleTimeAmPm(item.date_time_of_change)}`}
                                                      </span>
                                                    </Typography>
                                                    <Chip
                                                      label={item.reason_data_changed}
                                                      color="success"
                                                      size="small"
                                                    />
                                                  </Stack>
                                                  <Typography component="div" gutterBottom variant="body2">
                                                    <strong>Data Changed To:</strong> {item.changed_data}
                                                  </Typography>

                                                  {!getExpandAndCollapseState(item.id) && (
                                                    <Typography component="div" gutterBottom variant="body2">
                                                      <strong>Entered By:</strong> {item.audit_user_name}
                                                    </Typography>
                                                  )}
                                                  {getExpandAndCollapseState(item.id) && (
                                                    <Typography component="div" gutterBottom variant="body2">
                                                      <strong>Previous Value:</strong> {item.data_changed_from}
                                                    </Typography>
                                                  )}
                                                </Box>
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Field:</strong> {item.field_label}
                                                </Typography>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Entered By:</strong> {item.audit_user_name}
                                                </Typography>
                                                {/* <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Reason for change:</strong>
                                                </Typography> */}
                                              </AccordionDetails>
                                            </Accordion>
                                          ) : (
                                            <Accordion
                                              key={item.id}
                                              disabled={false}
                                              expanded={getExpandAndCollapseState(item.id)}
                                              onChange={(e, expanded) => {
                                                handleChangeAccordion(e, expanded, item.id);
                                              }}
                                              className="CustomAccordion-AH"
                                            >
                                              <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1bh-content"
                                                id="panel1bh-header"
                                              >
                                                <Box>
                                                  <Stack
                                                    spacing={1.5}
                                                    direction="row"
                                                    sx={{ alignItems: 'center', mb: 1 }}
                                                  >
                                                    <Typography variant="h6" component="div">
                                                      {queryKeys.report_section_name}: {item.report_field_name}
                                                    </Typography>
                                                    <Typography variant="body2" gutterBottom>
                                                      <span>
                                                        {`${preferedDateFormat(
                                                          item.date_time_of_change.split('T')[0]
                                                        )} ${handleTimeAmPm(item.date_time_of_change)}`}
                                                      </span>
                                                    </Typography>
                                                    <Chip
                                                      label={item.reason_data_changed}
                                                      color="success"
                                                      size="small"
                                                    />
                                                  </Stack>
                                                  <Typography component="div" gutterBottom variant="body2">
                                                    Query #
                                                    {item.report_query_type === 'Field'
                                                      ? item.report_field_query_id_v
                                                      : item.report_section_query_id_v}{' '}
                                                    Raised
                                                  </Typography>
                                                  <Typography component="div" gutterBottom variant="body2">
                                                    Created By: {item.created_by}
                                                  </Typography>
                                                </Box>
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  {item.report_query_type === 'Field'
                                                    ? `Field: ${
                                                        queryType === 'Field'
                                                          ? queryKeys.report_field_label
                                                          : getFieldLabelByFieldName(item.report_field_name)
                                                      }`
                                                    : `Section: ${queryKeys.report_section_name}`}
                                                </Typography>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  {item.report_forward_to != '' ? 'Initially Sent To' : 'Send To'}:{' '}
                                                  {item.report_send_to}{' '}
                                                </Typography>

                                                {item.report_forward_to != '' && (
                                                  <Typography component="div" gutterBottom variant="body2">
                                                    Forwarded To: {item.report_forward_to}
                                                  </Typography>
                                                )}
                                                <Typography component="div" gutterBottom variant="body2">
                                                  Message: {item.report_comment}{' '}
                                                </Typography>
                                                {item.responses && item.responses?.length > 0 && (
                                                  <Box>
                                                    <Stack
                                                      spacing={1.5}
                                                      direction="row"
                                                      sx={{ alignItems: 'center', mb: 1, mt: 2 }}
                                                    >
                                                      <Typography variant="h6" component="div">
                                                        {item.responses.length} Response(s)
                                                      </Typography>
                                                    </Stack>
                                                  </Box>
                                                )}
                                                <Grid container>
                                                  {item.responses &&
                                                    item.responses.map((res: any) => {
                                                      return (
                                                        <Grid
                                                          container
                                                          key={res.id}
                                                          className="query-card comment-section"
                                                        >
                                                          <Grid md={12} className="name-section" sx={{ pl: 2 }}>
                                                            <AccountCircleIcon /> {res.created_by}{' '}
                                                            <span>
                                                              {`${preferedDateFormat(
                                                                res.created_on.split('T')[0]
                                                              )} ${handleTimeAmPm(res.created_on)}`}
                                                              {/* {new Date(res.created_on)
                                                                .toLocaleDateString('en-US', {
                                                                  hour: 'numeric',
                                                                  minute: '2-digit',
                                                                  hour12: true
                                                                })
                                                                .replace(/,/g, '')} */}
                                                            </span>
                                                          </Grid>
                                                          <Grid md={12} sx={{ pl: 2.5, mb: 2, wordBreak: 'break-all' }}>
                                                            <span className="sub-text">
                                                              Response: {res.query_response}
                                                            </span>
                                                          </Grid>
                                                        </Grid>
                                                      );
                                                    })}
                                                </Grid>
                                              </AccordionDetails>
                                            </Accordion>
                                          )}
                                        </>
                                      );
                                    })}
                                  </Box>
                                ))
                              : !isLoading && (
                                  <Typography
                                    key={1}
                                    variant="body1"
                                    gutterBottom
                                    sx={{ textAlign: 'center', color: 'rgba(0,0,0,0.6)', my: 4, width: '100%' }}
                                  >
                                    No audit trail details found for selected field/filter criteria
                                  </Typography>
                                )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </div>
          {paginatedAuditDetails.length > 0 && Object.keys(paginatedAuditDetails).length !== 0 && (
            <Stack spacing={2} className="siv-pagination milestone-audit-pagination">
              <Pagination
                count={Math.ceil(noOfAuditResults / perPage)}
                page={page}
                onChange={handlePagination}
                disabled={paginatedAuditDetails.length === 0}
              />
            </Stack>
          )}
        </DialogContent>
        <DialogActions id="no-print">
          <Stack direction="row" spacing={2}>
            <Button variant="text" href="#contained-buttons" onClick={handleCloseFieldAudit}>
              Close
            </Button>
          </Stack>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};
